import React from 'react';
import { Users, Gift, ArrowRight, UserPlus, CreditCard, Sparkles } from 'lucide-react';

const ReferralSection: React.FC = () => {
  return (
    <section className="py-20 bg-dark">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-r from-primary/20 to-black/50 backdrop-blur-sm p-8 md:p-12 border-2 border-primary/50">
            <div className="text-center mb-12">
              <Gift className="text-primary mx-auto mb-4" size={48} />
              <h2 className="font-bebas text-4xl md:text-6xl text-white mb-4 tracking-wider">
                BRING A FRIEND. <span className="text-primary">GET REWARDED.</span>
              </h2>
              <p className="font-montserrat text-gray-300 text-lg max-w-2xl mx-auto">
                For every friend you refer who signs up, you both earn a free session. 
                Fitness is better together—so start sharing today!
              </p>
            </div>

            {/* How It Works */}
            <div className="mb-12">
              <h3 className="font-bebas text-3xl text-primary text-center mb-8 tracking-wider">
                HOW IT WORKS
              </h3>
              
              <div className="grid md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="bg-primary/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <UserPlus className="text-primary" size={24} />
                  </div>
                  <div className="font-bebas text-5xl text-primary/30 mb-2">01</div>
                  <h4 className="font-montserrat font-bold text-white mb-2">INVITE</h4>
                  <p className="text-gray-400 font-montserrat text-sm">
                    Invite a friend, family member, or colleague to train with us
                  </p>
                </div>

                <div className="text-center">
                  <div className="bg-primary/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <CreditCard className="text-primary" size={24} />
                  </div>
                  <div className="font-bebas text-5xl text-primary/30 mb-2">02</div>
                  <h4 className="font-montserrat font-bold text-white mb-2">THEY SIGN UP</h4>
                  <p className="text-gray-400 font-montserrat text-sm">
                    When they sign up for any package, you're both eligible
                  </p>
                </div>

                <div className="text-center">
                  <div className="bg-primary/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Sparkles className="text-primary" size={24} />
                  </div>
                  <div className="font-bebas text-5xl text-primary/30 mb-2">03</div>
                  <h4 className="font-montserrat font-bold text-white mb-2">BOTH REWARDED</h4>
                  <p className="text-gray-400 font-montserrat text-sm">
                    You both receive a free session to use anytime
                  </p>
                </div>
              </div>
            </div>

            {/* Benefits */}
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div className="bg-black/50 p-6 border border-gray-800">
                <h4 className="font-montserrat font-bold text-white mb-3">For You:</h4>
                <ul className="space-y-2">
                  <li className="flex items-center text-gray-300">
                    <ArrowRight className="text-primary mr-2" size={16} />
                    <span className="font-montserrat text-sm">Free session for each referral</span>
                  </li>
                  <li className="flex items-center text-gray-300">
                    <ArrowRight className="text-primary mr-2" size={16} />
                    <span className="font-montserrat text-sm">No limit on referrals</span>
                  </li>
                  <li className="flex items-center text-gray-300">
                    <ArrowRight className="text-primary mr-2" size={16} />
                    <span className="font-montserrat text-sm">Stack your free sessions</span>
                  </li>
                </ul>
              </div>

              <div className="bg-black/50 p-6 border border-gray-800">
                <h4 className="font-montserrat font-bold text-white mb-3">For Your Friend:</h4>
                <ul className="space-y-2">
                  <li className="flex items-center text-gray-300">
                    <ArrowRight className="text-primary mr-2" size={16} />
                    <span className="font-montserrat text-sm">Free bonus session</span>
                  </li>
                  <li className="flex items-center text-gray-300">
                    <ArrowRight className="text-primary mr-2" size={16} />
                    <span className="font-montserrat text-sm">Trusted recommendation</span>
                  </li>
                  <li className="flex items-center text-gray-300">
                    <ArrowRight className="text-primary mr-2" size={16} />
                    <span className="font-montserrat text-sm">Training partner option</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center">
              <p className="text-primary font-bebas text-2xl mb-4">
                THE MORE PEOPLE YOU REFER, THE MORE REWARDS YOU EARN!
              </p>
              <button 
                onClick={() => {
                  const element = document.querySelector('#booking');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-primary hover:bg-red-600 text-white font-montserrat font-bold px-8 py-4 text-lg tracking-wider transition-all duration-300 transform hover:scale-105"
              >
                START REFERRING TODAY
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferralSection;